import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("UI error boundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4">
          <div className="max-w-xl w-full bg-zinc-900/70 border border-zinc-800 rounded-xl p-8 shadow-xl">
            <h1 className="text-2xl font-semibold text-zinc-100 mb-2">Unexpected UI Error</h1>
            <p className="text-sm text-zinc-400 mb-4">
              The dashboard hit an unexpected error while rendering. Please reload or return to the dashboard.
            </p>
            <pre className="text-xs text-zinc-500 whitespace-pre-wrap bg-zinc-950/70 border border-zinc-800 rounded-lg p-3 mb-6">
              {String(this.state.error)}
            </pre>
            <div className="flex gap-3">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-md bg-zinc-800 text-zinc-100 hover:bg-zinc-700 transition-colors"
              >
                Reload
              </button>
              <button
                onClick={() => (window.location.href = "/")}
                className="px-4 py-2 rounded-md bg-amber-500 text-zinc-900 hover:bg-amber-400 transition-colors"
              >
                Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
